import {createContext,useContext,useEffect,useState,type ReactNode} from 'react';
import {apiJSON} from '../../lib/client';
import type {PublicConfig} from '../../../../shared/model';
type Context={settings:PublicConfig;ready:boolean;error:string;refresh:()=>void};
const initial:PublicConfig={site_id:1,site_name:'TRWIN',logo_url:'/assets/trwin-logo.png',mobile_logo_url:'',currency:'TRY',spin_wheel_display:{enabled:false,segments:[]},localPreview:false,allowedParentOrigins:[],bannerUrl:'',tvEnabled:true};
const SiteContext=createContext<Context>({settings:initial,ready:false,error:'',refresh:()=>{}});
export function SiteSettingsProvider({children}:{children:ReactNode}){
 const[settings,setSettings]=useState(initial),[ready,setReady]=useState(false),[error,setError]=useState(''),[revision,setRevision]=useState(0);
 useEffect(()=>{
  const controller=new AbortController();let inFlight=false,loaded=false;
  setReady(false);
  const load=async()=>{
   if(inFlight||controller.signal.aborted)return;
   inFlight=true;
   try{
    const data=await apiJSON<PublicConfig>('/api/public',undefined,'member',AbortSignal.any([controller.signal,AbortSignal.timeout(20000)]));
    if(controller.signal.aborted)return;
    if(!Array.isArray(data.allowedParentOrigins)||!data.spin_wheel_display)throw Error('Site bağlantısı doğrulanamadı.');
    const next={...data,tvEnabled:data.tvEnabled!==false};
    setSettings(current=>JSON.stringify(current)===JSON.stringify(next)?current:{...next,
     // A publication toggle must not restart authentication or the wheel.
     allowedParentOrigins:JSON.stringify(current.allowedParentOrigins)===JSON.stringify(next.allowedParentOrigins)?current.allowedParentOrigins:next.allowedParentOrigins,
     spin_wheel_display:JSON.stringify(current.spin_wheel_display)===JSON.stringify(next.spin_wheel_display)?current.spin_wheel_display:next.spin_wheel_display,
    });
    loaded=true;setError('');setReady(true);
   }catch(e){if(!controller.signal.aborted&&!loaded)setError(e instanceof Error?(e.name==='TimeoutError'?'Site bilgileri alınamadı. Bağlantıyı yenileyin.':e.message):'Siteye bağlanılamadı.');}
   finally{inFlight=false;}
  };
  const wake=()=>{if(document.visibilityState==='visible')void load();};
  void load();
  const timer=window.setInterval(wake,30000);
  window.addEventListener('focus',wake);document.addEventListener('visibilitychange',wake);
  return()=>{controller.abort();clearInterval(timer);window.removeEventListener('focus',wake);document.removeEventListener('visibilitychange',wake);};
 },[revision]);
 return<SiteContext.Provider value={{settings,ready,error,refresh:()=>setRevision(r=>r+1)}}>{children}</SiteContext.Provider>;
}
export function useSiteSettings(){return useContext(SiteContext);}
